// System-wide notifications. This file is the source of truth — edit/append
// here, redeploy to Cloudflare Pages, and the bell will surface new entries
// to every visitor (no per-user backend). Read state lives in a cookie keyed
// by id, so changing an existing id will resurface that entry as unread.
//
// Use *asterisks* around a span to render it bold in the bell panel.

export interface Notification {
  id: string;
  date: string; // ISO date (YYYY-MM-DD)
  title: { tr: string; en: string };
  body: { tr: string; en: string };
  signature?: { tr: string; en: string };
}

export const notifications: Notification[] = [
  {
    id: '2026-05-31-ilk-ay-114-musteri',
    date: '2026-05-31',
    title: {
      tr: 'İlk Ay Teşekkürü',
      en: 'First Month Thank You',
    },
    body: {
      tr: 'İlk ayda *114* memnun müşteriye ulaşmamızı sağlayan reklam ekibimizi tebrik ediyorum. Müşterilerimiz bize mesaj atarak istedikleri özellikleri hızlı süreçlerle ekletebileceklerini unutmasınlar.',
      en: 'Congratulations to our advertising team for helping us reach *114* satisfied customers in our first month. Our customers should remember that they can message us to have desired features added through quick processes.',
    },
    signature: {
      tr: 'Polysan Yazılım LTD. Genel Müdürü Sakıp Emre Öztürk',
      en: 'Sakıp Emre Öztürk, General Manager of Polysan Yazılım LTD.',
    },
  },
];
